var _style, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_svg__katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 4433.7 3012",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_svg__st2{fill:#2d72b8}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2539.1 2751.7h30.3l495.3-247.7 8.2-11.7V515.2l-8.2-11.7L2569.5 256h-30.7l.3 2495.7",
    fill: "#5294cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1894.5 2751.7h-30.8L1368.8 2504l-10-17.3-5.1-1961.4 15.1-21.8 495-247.5h31.2l-.5 2495.7",
    fill: "#1f5b98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__st2",
    d: "M1864.6 256H2569v2495.7h-704.4V256z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3324.1 1447.8l-16.7-3.7-239-22.3-3.5 1.8-495.8-19.8h-704.4l-495.8 19.8v-378.1l-.5.3.5-1.1 495.8-114.9H2569l495.8 114.9 182.3 96.9v-62.3l77-8.4-8-15.6-243.9-174.4-7.4 2.4L2569 729.7h-704.4l-495.8 153.6V503.5l-259.3 303.7v265.3l2-1.5 75 8.2v63.6l-77 41.2v264l2-.2 75 1.1v110.8l-64.7 1-12.3-1.2v264.1l77 41.4v64.3l-73.8 8.1-3.2-2.4v265.2l259.3 303.8v-379.8l495.8 153.6H2569l497.2-154.1 6.6 2.9 240.7-171.8 10.5-17.1-77-8.5v-63l-10.1-4-164.7 88.8-6 12.5-497.2 114.2v.1h-704.4v-.1L1368.8 1963v-379.4l495.8 19.8v.5H2569l495.8-20.2 11.3 5.2 231.7-19.9 16.3-8-77-1.1v-110.8l77-1.3",
    fill: "#1a476f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__st2",
    d: "M3064.8 2124.2V2504l259.3-303.8v-263.5l-257.8 187.1-1.5.4m0-160.4l1.5-.3 257.8-138.7v-265.1l-259.3 23.8v380.3m1.5-918.8l-1.5-.3v378.9l259.3 24.2v-265L3066.3 1045m0-160.2l257.8 186V807.3l-259.3-303.8v379.8l1.5.5v1"
  })));
}

export default SvgIcon;